import "./EmployeeAbsence.css";
import { useEffect, useState } from "react";
import CancelButton from "../../../../../sharedComponents/cancelButton/CancelButton";
import PrimaryButton from "../../../../../sharedComponents/primaryButton/PrimaryButton";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { CustomProvider, DatePicker } from "rsuite";
import EmployeeCreationAbsence from "./creation/EmployeeCreationAbsence";
import { Calendar } from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import AbsenceList from "./absenceList/AbsenceList";
import { deDE } from 'rsuite/locales';
import Logout from "../../../../../sharedComponents/Logout";

const weekDays = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
const months = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]

function EmployeeAbsence(){
    /** 
     * when creating vacation always on the first of month;
     * check in what month the absence-period is 
     * hours in one absence-period is same 
     * ignore specific day = true
     * 
     * Darstellung: in Tabelle mit vier Listen (ähnlich wie Footer) um bezahlten/ unbezahlten Urlaub/Krankheit
    */

    const [refresh, setRefresh] = useState(false);

    const [selectedMonth, setSelectedMonth] = useState(new Date());

    // Removing Modal
    const [openRemovingModal, setOpenRemovingModal] = useState(false);
    const handleCloseRemovingModal = () => {
        setRemovingAbsenceError(false);
        setOpenRemovingModal(false);
    }

    const [removingAbsenceError, setRemovingAbsenceError] = useState(false);

    const [selectedDateArray, setSelectedDateArray] = useState([]);
    const [openDetailModal, setOpenDetailModal] = useState(false);
    const handleCloseDetailModal = () => {
        setOpenDetailModal(false);
    }

    const [selectedId, setSelectedId] = useState("");
    const [absences, setAbsences] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                axios.get('absence/getAllAbsencePeriodsForEmployeeWithId?id=' + new URLSearchParams(window.location.search).get("employeeId")).then(results => {
                    setAbsences(results.data);
                })
            } catch (error){
                Logout();
            }
        }
        fetchData();
    }, [refresh])

    function sendDeleteRequest() {
        axios.delete('absence/deleteAbsencePeriodWithId?id=' + selectedId, {
        }).then(() => {
            handleCloseRemovingModal();
            setRemovingAbsenceError(false);
            setRefresh(!refresh);
        }).catch(() => setRemovingAbsenceError(true)); 
    }

    

    function terminatedAbsenceModal() {
        return (
            <Modal
                show={openDetailModal}
                onHide={handleCloseDetailModal}
                keyboard={true}
            >
                <Modal.Header>
                        <Modal.Title>Abwesenheit</Modal.Title>
                        <button type="button" className="close" aria-label="Close" onClick={handleCloseDetailModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </Modal.Header>
                    <Modal.Body className="detail-view-calendar">
                        <Calendar 
                            multiple
                            format="DD.MM.YYYY"
                            readOnly
                            weekDays={weekDays}
                            months={months}
                            highlightToday={false}
                            value={selectedDateArray} 
                            weekStartDayIndex={1}
                            plugins={[
                                <DatePanel sort="date" header="Ausgewählt" removeButton={false}/>
                            ]}
                        /> 
                    </Modal.Body>
                    <Modal.Footer>
                        <PrimaryButton text="Okay" onClick={handleCloseDetailModal} />
                    </Modal.Footer>
            </Modal>
        )
    }

    function removeAbsenceModal() {
        return (
            <Modal
                show={openRemovingModal}
                onHide={handleCloseRemovingModal}
                keyboard={true}
            >
                <Modal.Header>
                        <Modal.Title>Abwensenheit löschen</Modal.Title>
                        <button type="button" className="close" aria-label="Close" onClick={handleCloseRemovingModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Möchten Sie wirklich diese Abwesenheit löschen?</p>  
                        {removingAbsenceError && <p className="red">Ein Fehler ist aufgetreten.</p>}              
                    </Modal.Body>
                    <Modal.Footer>
                        <CancelButton text="Abbrechen" onClick={handleCloseRemovingModal} />
                        <PrimaryButton text="Abwesenheit löschen" onClick={() => sendDeleteRequest()} />
                    </Modal.Footer>
            </Modal>
        )
    }

    const handleTodayClick = () =>  {
        const newDay = new Date();
        setSelectedMonth(newDay);
    }

    return (
            <>
                <EmployeeCreationAbsence refresh={refresh} setRefresh={setRefresh} absences={absences} />
                {removeAbsenceModal()}
                <div className="employee-absence-select">
                    <CustomProvider locale={deDE}>
                        <DatePicker
                            className="dashboard-datepicker"
                            cleanable={false}
                            label="Monat"
                            oneTap
                            required
                            format="MMM yyyy"
                            size="lg"
                            placeholder="Startmonat"
                            value={selectedMonth}
                            onSelect={(value) => setSelectedMonth(value)}
                        />
                    </CustomProvider>                    
                    <PrimaryButton text="Heute" onClick={handleTodayClick} />
                </div>
                <div className="month-container">    
                    <AbsenceList 
                        absences={absences}
                        setDateArray={setSelectedDateArray} 
                        setSelectedId={setSelectedId} 
                        selectedMonth={selectedMonth} 
                        setOpenDetailModal={setOpenDetailModal}
                        setOpenRemovingModal={setOpenRemovingModal}
                    />
                </div>                
                {terminatedAbsenceModal()}
            </>
        )
}

export default EmployeeAbsence;